import React from 'react';
import { DatePickerPropsFromParent, SkioldDatePicker } from './skiold-date-picker';

export class SkioldFormDatePicker extends React.PureComponent<DatePickerPropsFromParent> {
    public render() {
        return <SkioldDatePicker {...this.props} theme={'dark'} />;
    }
}
